// extracted by mini-css-extract-plugin
export default {"photo":"FeedPhotosItem_photo__0y7P0","visualizacao":"FeedPhotosItem_visualizacao__re79Q"};